import {
    DropdownListContainerLI,
    DropdownListContainerLIWrapper,
} from "shared/components/inputs/dropdown/Dropdown.styles";
import { COLOR_VALUES } from "shared/config/colors";
import styled from "styled-components";

const labelInListStyles = `margin-bottom: 0;
display: flex;
align-items: center;
justify-content: flex-start;`;

export const StyledDropdownListContainerLIWrapper = styled(
    DropdownListContainerLIWrapper
)`
    padding-right: 4px;

    label {
        ${labelInListStyles}
    }
`;

export const DropdownListContainerLIStyled = styled(DropdownListContainerLI)`
    cursor: default;

    div {
        width: inherit;
    }

    label {
        width: 100%;
        cursor: pointer;
    }
`;

export const StyledUL = styled.ul`
    list-style-type: none;
    padding-inline-start: 16px;

    li {
        padding: 8px 6px;
    }

    li:first-child {
        padding-top: 6px;
    }

    li:last-child {
        border-bottom-color: ${COLOR_VALUES.Gray_5};
        margin-bottom: 4px;
    }
`;
